// services/seoAPIServices.js
import api from "./apiServices"; // Assuming your axios instance is here

export const seoServices = {
  // 1. List Pages with advanced filters
  listPages: async (params) => {
    // params: { audience, category_id, location_id, page_type, page, limit }
    const { data } = await api.get("/admin/seo/pages", { params });
    return data;
  },

  // 2. Create Page
  createPage: async (payload) => {
    const { data } = await api.post("/admin/seo/pages", payload);
    return data;
  },

  // 3. Update Page
  updatePage: async (id, payload) => {
    const { data } = await api.patch(`/admin/seo/pages/${id}`, payload);
    return data;
  },

  // 4. Bulk Generate
  bulkGenerate: async (payload) => {
    const { data } = await api.post("/admin/seo/bulk-generate", payload);
    return data;
  },

  // 5. Search Locations
  searchLocations: async (query, countryCode, stateCode = null) => {
    const params = { q: query, country_code: countryCode };
    if (stateCode) params.state_code = stateCode;
    const { data } = await api.get("/admin/seo/locations/search", { params });
    return data;
  },

  // 6. Search Groups
  searchGroups: async (query, countryCode) => {
    const { data } = await api.get("/admin/seo/groups/search", {
      params: { q: query, country_code: countryCode },
    });
    return data;
  },
  getSanityDocs: async (docType, titleType, audienceType, countryCode, language) => {
    const params = docType ? { doc_type: docType, title_type: titleType || null, audience_type: audienceType || 'BUYER', country_code: countryCode || 'IN', language: language || 'en' } : {};
    const { data } = await api.get('/admin/seo/sanity-docs', { params });
    return data;
  },
};
